import { render } from "./Presentation.vue?vue&type=template&id=67a8d29e&scoped=true"
import script from "./Presentation.vue?vue&type=script&lang=ts"
export * from "./Presentation.vue?vue&type=script&lang=ts"

import "./Presentation.vue?vue&type=style&index=0&id=67a8d29e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-67a8d29e"

export default script